import request from '@/utils/zsm-requets'
var share = '/zsm/api/share/'
var kapiShare2 = '/zsm/kapi/share/' // 知识库

/** 挂载新接口
 distId:'',//用户编号
 distName:'',//用户名称
 linkPath:'',//挂载链接
 goodId:'',//商品封面
 title:'',//标题
 platformDict:'douyin',//标题
 coverPath:'',//图片url
 videoPath:'',//(视频url)，
 videoSize:'',//视频大小
 goodName:'',//课程名称
 参数 https://file.jinglinshe.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20220412162055.png
 */
export function portalShareKapi(params) {
  return request({
    url: kapiShare2 + 'portal',
    method: 'post',
    params
  })
}

/** 新增分享数据
 cover封面
 goodId 商品
 goodName 商品名称
 platformDict平台
 distId分享人
 distName分享名称
 title分享标题

 */
export function createShareKapi(params) {
  return request({
    url: kapiShare2 + 'create',
    method: 'post',
    params
  })
}

/**
 * 发布抖音视频
 */
export function createVideoShareKapi(params) {
  return request({
    url: kapiShare2 + 'createVideo',
    method: 'post',
    params
  })
}

/**
 * 上传素材图片
 *
 *filePath
 frontId
 */
export function uploadImageShareKapi(filePath, frontId) {
  return request({
    url: kapiShare2 + 'uploadImage',
    method: 'post',
    params: { filePath, frontId }
  })
}

/**
 * 上传素材视频
 *
 *filePath
 frontId
 */
export function uploadVideoShareKapi(filePath, frontId) {
  return request({
    url: kapiShare2 + 'uploadVideo',
    method: 'post',
    params: { filePath, frontId }
  })
}

/**
 * 上传素材视频
 *
 *filePath 地址
 frontId	前端用户
 size		大小
 */
export function uploadVideoOneShareKapi(filePath, frontId, size) {
  return request({
    url: kapiShare2 + 'uploadVideoOne',
    method: 'post',
    params: { filePath, frontId, size }
  })
}

/**
 获取分享列表 distId
 */
export function listDataShareKapi(params) {
  return request({
    url: kapiShare2 + 'listData',
    method: 'post',
    params
  })
}

/**
 删除分享列表和抖音视频
 */
export function deleteShareKapi(id) {
  return request({
    url: kapiShare2 + 'delete',
    method: 'post',
    params: { id }
  })
}

/** 挂载新接口
          distId:'',//用户编号
          distName:'',//用户名称
          linkPath:'',//挂载链接
          goodId:'',//商品封面
          title:'',//标题
          platformDict:'douyin',//标题
          coverPath:'',//图片url
          videoPath:'',//(视频url)，
          videoSize:'',//视频大小
          goodName:'',//课程名称
  参数 https://file.jinglinshe.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20220412162055.png
 */
export function portalShare(params) {
  return request({
    url: share + 'portal',
    method: 'post',
    params
  })
}

/** 新增分享数据
   cover封面
   goodId 商品
   goodName 商品名称
   platformDict平台
   distId分享人
   distName分享名称
   title分享标题

 */
export function createShare(params) {
  return request({
    url: share + 'create',
    method: 'post',
    params
  })
}

/**
 * 发布抖音视频
 */
export function createVideoShare(params) {
  return request({
    url: share + 'createVideo',
    method: 'post',
    params
  })
}

/**
 * 上传素材图片
 *
 *filePath
  frontId
 */
export function uploadImageShare(filePath, frontId) {
  return request({
    url: share + 'uploadImage',
    method: 'post',
    params: { filePath, frontId }
  })
}

/**
 * 上传素材视频
 *
 *filePath
  frontId
 */
export function uploadVideoShare(filePath, frontId) {
  return request({
    url: share + 'uploadVideo',
    method: 'post',
    params: { filePath, frontId }
  })
}

/**
 * 上传素材视频
 *
 *filePath 地址
  frontId	前端用户
  size		大小
 */
export function uploadVideoOneShare(filePath, frontId, size) {
  return request({
    url: share + 'uploadVideoOne',
    method: 'post',
    params: { filePath, frontId, size }
  })
}

/**
  获取分享列表 distId
 */
export function listDataShare(params) {
  return request({
    url: share + 'listData',
    method: 'post',
    params
  })
}

/**
   删除分享列表和抖音视频
 */
export function deleteShare(id) {
  return request({
    url: share + 'delete',
    method: 'post',
    params: { id }
  })
}

// id生成
export function commonNextId() {
  return request({
    url: '/zsm/api/common/nextId',
    method: 'post'
  })
}
